import { render } from "./FungusRecordForm.vue?vue&type=template&id=76f75466&scoped=true&ts=true"
import script from "./FungusRecordForm.vue?vue&type=script&lang=ts"
export * from "./FungusRecordForm.vue?vue&type=script&lang=ts"

import "./FungusRecordForm.vue?vue&type=style&index=0&id=76f75466&scoped=true&lang=css"

import exportComponent from "C:\\Users\\wotruba\\IdeaProjects\\fungus_data_tool\\frontend-vue3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76f75466"]])

export default __exports__